import { Link } from 'react-router-dom';
import { LegalPageLayout } from './LegalPageLayout';

const EFFECTIVE_DATE = 'March 1, 2026';
const VERSION = '1.0';

export default function SubscriptionAddendum() {
  return (
    <LegalPageLayout>
      <h1>Subscription Addendum</h1>
      <p><strong>No Doubles Golf Co.</strong></p>
      <p><strong>Version:</strong> {VERSION}</p>
      <p><strong>Effective Date:</strong> {EFFECTIVE_DATE}</p>
      <p>
        This Subscription Addendum supplements and is incorporated into the No Doubles Golf Co.{' '}
        <Link to="/terms">Terms of Service</Link> ("Terms"). Capitalized terms not defined here
        have the meanings assigned in the Terms.
      </p>

      <hr />

      <h2>1. Subscription Tiers</h2>
      <p>
        No Doubles may offer multiple subscription tiers with varying features, content access, and
        pricing. Current subscription options are described within the Service at the time of
        purchase.
      </p>

      <hr />

      <h2>2. Billing Platforms</h2>
      <h3>2.1 Apple In-App Purchase</h3>
      <p>
        Apple processes all payments for iOS subscriptions. Apple's terms of service and refund
        policies apply. Refund requests must be submitted to Apple directly at{' '}
        <a href="https://reportaproblem.apple.com" target="_blank" rel="noopener noreferrer">
          reportaproblem.apple.com
        </a>.
      </p>
      <h3>2.2 Google Play Billing</h3>
      <p>
        Google is the merchant of record for Android subscriptions. Google Play's terms and refund
        policies apply.
      </p>
      <h3>2.3 Stripe (Web)</h3>
      <p>
        Stripe, Inc. processes web payments. We do not store your full credit card number. Refund
        requests for web subscriptions may be submitted within 30 days of the charge date. For
        Canadian residents, refund rights under applicable provincial consumer protection law are
        preserved regardless of this timeframe.
      </p>

      <hr />

      <h2>3. Auto-Renewal</h2>
      <p>
        <strong>
          All subscriptions auto-renew at the end of each billing period unless you cancel before
          the renewal date.
        </strong>{' '}
        You will be charged the then-current subscription price at the time of renewal. By
        subscribing, you expressly consent to automatic recurring charges.
      </p>

      <hr />

      <h2>4. Cancellation</h2>
      <table>
        <thead><tr><th>Platform</th><th>How to Cancel</th></tr></thead>
        <tbody>
          <tr><td><strong>Apple</strong></td><td>Device Settings &gt; Apple ID &gt; Subscriptions &gt; No Doubles &gt; Cancel</td></tr>
          <tr><td><strong>Google Play</strong></td><td>Google Play &gt; Subscriptions &gt; No Doubles &gt; Cancel</td></tr>
          <tr><td><strong>Web (Stripe)</strong></td><td>Account Settings or email support</td></tr>
        </tbody>
      </table>
      <p>
        Cancellation takes effect at the end of the current paid billing period. You retain access
        until then. No partial refunds are provided except as required by law.
      </p>
      <h3>4.3 Cancellation Ease</h3>
      <p>
        Cancellation does not require contacting customer support, completing a survey, or
        navigating multiple confirmation screens. The process is designed to be as simple as the
        signup process.
      </p>

      <hr />

      <h2>5. Free Trials</h2>
      <p>
        If a free trial is offered, it will convert to a paid subscription automatically unless you
        cancel before the trial ends. Free trials are limited to one per user/account. Any unused
        portion of a free trial is forfeited upon purchasing a paid subscription.
      </p>

      <hr />

      <h2>6. Price Changes</h2>
      <p>
        We will provide reasonable advance notice of price increases. Price changes take effect at
        the start of your next billing period. You may cancel if you do not agree to the new price.
      </p>

      <hr />

      <h2>7. Chargebacks and Payment Disputes</h2>
      <p>
        Please contact us before initiating a chargeback. Chargebacks without prior resolution
        attempt may result in account suspension.
      </p>

      <hr />

      <h2>8. Promotional Pricing and Introductory Offers</h2>
      <h3>8.1 Introductory Offers</h3>
      <p>
        No Doubles may offer introductory pricing, including free trials, discounted first periods,
        and pay-up-front promotional rates. The specific terms of any introductory offer will be
        clearly disclosed before you subscribe, including:
      </p>
      <ul>
        <li>The duration of the promotional period</li>
        <li>The regular price that will apply after the promotional period ends</li>
        <li>Whether the subscription auto-renews at the regular price after the promotional period</li>
      </ul>
      <h3>8.2 Eligibility</h3>
      <p>
        Introductory offers are generally available only to new subscribers who have not previously
        subscribed to the same plan. Eligibility is determined by the billing platform.
      </p>
      <h3>8.3 Platform-Specific Offers</h3>
      <p>
        Apple and Google may offer their own promotional mechanisms (e.g., Apple offer codes, Google
        developer offers). The terms of these promotions are governed by the applicable platform's
        policies in addition to this Addendum.
      </p>

      <hr />

      <h2>9. Cross-Platform Subscription Notice</h2>
      <p>
        Subscriptions are not transferable between platforms. Cancel your existing subscription
        before subscribing on a different platform to avoid duplicate charges.
      </p>
      <p>
        Where technically feasible, the Service may alert you if an active subscription is detected
        on another platform during the subscription flow.
      </p>

      <hr />

      <h2>10. Subscription Data</h2>
      <p>
        No Doubles may access subscription status data (active, cancelled, expired) to manage your
        access. We do not access or store your payment card information for Apple or Google Play
        subscriptions.
      </p>

      <hr />

      <h2>Contact</h2>
      <p>No Doubles Golf Co.</p>
      <p>Email: support@nodoublesgolf.com</p>
    </LegalPageLayout>
  );
}
